import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_select_date extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_select_date">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Select Date</h2>
              <p>
                The select date component provides the user the ability to
                select a date either by typing or through a calendar interface.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_select_date"}
                name={"select date"}
                dataNameDefault={
                  '"date_my_field" or "object_my_obj.date_my_field"'
                }
                autoFill={'"2018-06-21"'}
                padding={true}
                hide={true}
                order={true}
                button={false}
                tabIndex={true}
                readOnly={true}
                displayName={true}
                onChangeEval={true}
              />

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Select Date Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Select Date</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_select_date"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"date_my_field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My Date"</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_select_date;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_select_date.js